"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var lodash_isequal_1 = __importDefault(require("lodash.isequal"));
var useSelectItems_1 = __importDefault(require("./hooks/useSelectItems"));
var usePagination_1 = __importDefault(require("./hooks/usePagination"));
var useSorts_1 = __importDefault(require("./hooks/useSorts"));
var useFilters_1 = __importDefault(require("./hooks/useFilters"));
var usePrevious_1 = __importDefault(require("./hooks/usePrevious"));
var useLister = function (_a) {
    var api = _a.api, size = _a.size, behaviour = _a.behaviour, urlParams = _a.urlParams, singleSort = _a.singleSort, fixedParams = _a.fixedParams, useURLParameters = _a.useURLParameters, selecting = _a.selecting, search = _a.search, cacheableResources = _a.cacheableResources;
    var _b = useSorts_1.default(), sorts = _b[0], addSort = _b[1], removeSort = _b[2], clearSorts = _b[3], toggleSort = _b[4];
    var _c = useSelectItems_1.default(), selected = _c[0], selectItem = _c[1], deselectItem = _c[2], toggleSelectAll = _c[3], toggleSelectItem = _c[4], selectAll = _c[5], deselectAll = _c[6], allItemsAreSelected = _c[7];
    var _d = usePagination_1.default(), page = _d[0], setLastPage = _d[1], lastPage = _d[2], navigateToPage = _d[3], navigateBackwards = _d[4], navigateForwards = _d[5], gotoPage = _d[6];
    var _e = useFilters_1.default(), filters = _e[0], addFilter = _e[1], removeFilter = _e[2], clearFilters = _e[3];
    var _f = React.useState(null), cache = _f[0], setCache = _f[1];
    var _g = React.useState(''), searchItem = _g[0], setSearchItem = _g[1];
    var _h = React.useState([]), items = _h[0], setItems = _h[1];
    var _j = React.useState(0), overallCount = _j[0], setOverallCount = _j[1];
    var _k = React.useState(search.fields || []), searchFields = _k[0], setSearchFields = _k[1];
    var prevItems = usePrevious_1.default(items);
    var prevSelected = usePrevious_1.default(selected);
    var prevSorts = usePrevious_1.default(sorts);
    var prevFilters = usePrevious_1.default(filters);
    var prevPage = usePrevious_1.default(page);
    var prevSearchItem = usePrevious_1.default(searchItem);
    var typingTimeout = null;
    var resetState = function () {
        deselectAll();
        navigateToPage(1);
        clearSorts();
        clearFilters();
        setSearchItem('');
    };
    var constructQueryStringFromState = function (inclusions, includeFixedParams) {
        if (includeFixedParams === void 0) { includeFixedParams = false; }
        var params = new URLSearchParams();
        if (inclusions.includes('search') && searchItem.length > 0) {
            params.append('term', String(searchItem));
        }
        if (inclusions.includes('page')) {
            params.append('page', String(page));
        }
        if (inclusions.includes('size')) {
            params.append('size', String(size));
        }
        if (sorts.length > 0 && inclusions.includes('sorts')) {
            if (singleSort) {
                if (singleSort === true) {
                    var lastSort = void 0;
                    if (sorts.length !== 1) {
                        lastSort = sorts.pop();
                        if (lastSort) {
                            clearSorts();
                            addSort(lastSort);
                        }
                    }
                    params.append('sort', sorts[0].key + ":" + sorts[0].direction);
                }
                else {
                    params.append('sort', sorts.map(function (_a) {
                        var key = _a.key, direction = _a.direction;
                        return key + ":" + direction;
                    }).join());
                }
            }
            else {
                params.append('sort', sorts.map(function (_a) {
                    var key = _a.key, direction = _a.direction;
                    return key + ":" + direction;
                }).join());
            }
        }
        if (filters.length > 0 && inclusions.includes('filters')) {
            params.append('where', filters
                .map(function (_a) {
                var key = _a.key, value = _a.value;
                return key + ":" + (Array.isArray(value) ? value.join('|') : value);
            })
                .join());
        }
        if (fixedParams && includeFixedParams) {
            fixedParams.forEach(function (_a) {
                var key = _a[0], value = _a[1];
                params.append(key, value);
            });
        }
        var queryString = decodeURIComponent(params.toString());
        return queryString;
    };
    var constructPostBodyFromState = function (inclusions) {
        var termObj = inclusions.includes('search') && searchItem.length > 0 ? { term: String(searchItem) } : {};
        var pageObj = inclusions.includes('page') ? { page: page } : {};
        var sizeObj = inclusions.includes('size') ? { size: size } : {};
        var body = __assign(__assign(__assign(__assign(__assign({}, termObj), sizeObj), pageObj), { types: ["" + api.resource] }), { included_fields: search.included_fields });
        console.log('Body: ', body);
        return body;
    };
    var updateItemsViaAPI = React.useCallback(function (navigatedForwards) { return __awaiter(void 0, void 0, void 0, function () {
        var isSearch, url, endpoint, headers, resource, _a, method, _b, body, response, requestParams, requestUrl, data, updatedItems, updatedSelected, lastPageToSet;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    isSearch = searchItem.length > 0 && search.method === 'POST' && search.available;
                    url = api.url, endpoint = api.endpoint, headers = api.headers, resource = api.resource, _a = api.method, method = _a === void 0 ? 'GET' : _a, _b = api.body, body = _b === void 0 ? null : _b;
                    requestParams = __spreadArray([
                        'page',
                        'sorts',
                        'filters',
                        'search'
                    ], (size ? ['size'] : []));
                    if (!isSearch) return [3 /*break*/, 2];
                    return [4 /*yield*/, fetch(url + "search", {
                            headers: headers,
                            method: 'POST',
                            body: JSON.stringify(constructPostBodyFromState(requestParams)),
                        })];
                case 1:
                    // do search different
                    response = _c.sent();
                    return [3 /*break*/, 4];
                case 2:
                    requestUrl = "" + url + endpoint + "?" + constructQueryStringFromState(requestParams, true);
                    return [4 /*yield*/, fetch(requestUrl, {
                            headers: headers,
                            method: method,
                            body: body,
                        })];
                case 3:
                    response = _c.sent();
                    _c.label = 4;
                case 4: return [4 /*yield*/, response.json()];
                case 5:
                    data = _c.sent();
                    updatedItems = behaviour === 'append' && navigatedForwards && prevItems
                        ? __spreadArray(__spreadArray([], prevItems), data[isSearch ? 'results' : resource].filter(function (item) { return !prevItems.find(function (x) { return x.id === item.id; }); })) : data[isSearch ? 'results' : resource];
                    updatedSelected = behaviour === 'replace' ? [] : prevSelected;
                    if (data.pages) {
                        lastPageToSet = data.pages.last || 1;
                        setLastPage(lastPageToSet);
                    }
                    setItems(updatedItems);
                    if (updatedSelected !== undefined) {
                        toggleSelectAll(updatedSelected);
                    }
                    if (data.search_fields) {
                        setSearchFields(data.search_fields);
                    }
                    setOverallCount(Number(data.overall_count));
                    return [2 /*return*/];
            }
        });
    }); }, [page, sorts, filters, searchItem]);
    var updateLocationViaState = React.useCallback(function () {
        if (urlParams !== undefined && urlParams.length > 0) {
            var url = window.location.pathname + "?" + constructQueryStringFromState(urlParams, false);
            if (url !== window.location.pathname + window.location.search) {
                window.history.pushState(null, '', url);
            }
        }
    }, [urlParams]);
    var updateStateFromURL = function () {
        var params = new URLSearchParams(window.location.search);
        if (params !== null) {
            var updatedPage = Number(params.get('page')) >= 1 ? Number(params.get('page')) : 1;
            var updatedSorts = void 0;
            var sortParams = params.get('sort');
            if (sortParams !== null) {
                updatedSorts = sortParams.split(',').map(function (sort) {
                    var _a = sort.split(':'), key = _a[0], direction = _a[1];
                    return { key: key, direction: direction };
                });
            }
            else {
                updatedSorts = [];
            }
            var updatedFilters = void 0;
            var filterParams = params.get('where');
            if (filterParams !== null) {
                updatedFilters = filterParams.split(',').map(function (whereFilter) {
                    var _a = whereFilter.split(':'), key = _a[0], value = _a[1];
                    return { key: key, value: value.split('|') };
                });
            }
            else {
                updatedFilters = [];
            }
            navigateToPage(updatedPage);
            updatedSorts.forEach(function (item) { return addSort(item); });
            updatedFilters.forEach(function (item) { return addFilter(item); });
        }
    };
    var listerSearch = function (e) {
        if (typingTimeout) {
            clearTimeout(typingTimeout);
        }
        navigateToPage(1);
        setSearchItem(e.target.value);
        typingTimeout = setTimeout(function () {
            updateItemsViaAPI();
            if (useURLParameters) {
                updateLocationViaState();
            }
        }, 500);
    };
    var cacheCacheableResources = function () { return __awaiter(void 0, void 0, void 0, function () {
        var url, headers, cacheItems, updatedCache;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!cacheableResources) {
                        return [2 /*return*/];
                    }
                    url = api.url, headers = api.headers;
                    return [4 /*yield*/, Promise.all(cacheableResources.map(function (_a) {
                            var resource = _a.resource, endpoint = _a.endpoint;
                            return fetch("" + url + endpoint, { headers: headers })
                                .then(function (res) { return res.json(); })
                                .then(function (res) {
                                var _a;
                                return (_a = {}, _a[resource] = res[resource], _a);
                            });
                        }))];
                case 1:
                    cacheItems = _a.sent();
                    updatedCache = cacheItems.reduce(function (acc, cv) { return (__assign(__assign({}, acc), cv)); }, {});
                    setCache(updatedCache);
                    return [2 /*return*/];
            }
        });
    }); };
    React.useEffect(function () {
        cacheCacheableResources();
        if (window.location.search && useURLParameters) {
            // Update params from URL will cause CDU, thus fetching the items
            updateStateFromURL();
        }
        else {
            navigateToPage(1);
            updateItemsViaAPI().then(function () {
                if (useURLParameters) {
                    updateLocationViaState();
                }
            });
        }
    }, []);
    React.useEffect(function () {
        var pageHasChanged = prevPage !== page;
        var navigatedForwards = page === (prevPage && prevPage + 1);
        var sortHasChanged = !lodash_isequal_1.default(prevSorts, sorts);
        var filterHasChanged = !lodash_isequal_1.default(prevFilters, filters);
        var searchItemHasChanged = !lodash_isequal_1.default(prevSearchItem, searchItem) && searchItem === '';
        if (pageHasChanged || sortHasChanged || filterHasChanged || searchItemHasChanged) {
            if (useURLParameters) {
                updateLocationViaState();
            }
            updateItemsViaAPI(navigatedForwards);
        }
    }, [page, useURLParameters, filters, searchItem, sorts]);
    var generateReturn = function () {
        return {
            listerSearch: listerSearch,
            gotoPage: gotoPage,
            search: search.available,
            searchFields: searchFields,
            overallCount: overallCount,
            reset: resetState,
            permissions: {
                canNavigateForwards: page < lastPage,
                canNavigateBackwards: page > 1,
            },
            navigate: {
                forwards: navigateForwards,
                backwards: navigateBackwards,
                toPage: navigateToPage,
            },
            state: {
                items: items,
                selected: selected,
                page: page,
                lastPage: lastPage,
                sorts: sorts,
                filters: filters,
                cache: cache,
                search: search,
                searchItem: searchItem,
                searchFields: searchFields,
                overallCount: overallCount,
                typingTimeout: typingTimeout,
            },
            items: {
                update: updateItemsViaAPI,
                allSelected: allItemsAreSelected,
                select: selectItem,
                deselect: deselectItem,
                toggle: toggleSelectItem,
                selectAll: selectAll,
                deselectAll: deselectAll,
                toggleAll: toggleSelectAll,
            },
            filters: {
                clear: clearFilters,
                add: addFilter,
                remove: removeFilter,
            },
            sorts: {
                clear: clearSorts,
                add: toggleSort,
                remove: removeSort,
                toggle: toggleSort,
            },
        };
    };
    return generateReturn();
};
exports.default = useLister;
